<template>
  <div>
    <b-card-actions
      title="Sorting"
      action-collapse
      collapsed
    >
      <b-row>
        <!--Freeze Warehouse dropdown-->
        <b-col
          cols="6"
          :md="3"
        >
          <b-form-group
            label="Warehouse"
            label-for="freeze-warehouse"
          >
            <v-select
              id="freeze-warehouse"
              v-model="filters['destination_warehouse']"
              :options="warehouseOptions"
              :reduce="option => option.id"
              label="name"
              :disabled="freezeWarehouseCheckbox"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
          <b-freeze-label-info
            :left="90"
            :status-key="'key_10'"
          />
          <!--checkbox-->
          <div class="mt-1">
            <b-form-checkbox
              v-model="freezeWarehouseCheckbox"
              :disabled="!filters['destination_warehouse']"
            >
              Freeze Warehouse
            </b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card>
      <b-row>
        <b-col>
          <ValidationObserver
            v-slot="{ handleSubmit }"
            slim
          >
            <b-form
              class="my-8"
              @submit.prevent="handleSubmit(onSubmit)"
              @keydown.enter.prevent
            >
              <b-row>
                <b-col
                  cols="6"
                  :md="orderSettings.truck_driver_enabled ? 2 : 3"
                >
                  <div class="position-relative">
                    <b-form-group
                      label="Waybill Number"
                      label-for="waybill"
                    >
                      <b-form-input
                        id="waybill"
                        ref="waybill"
                        v-model="form.waybill_number"
                        type="text"
                        autocomplete="nope"
                        :disabled="loadingResponse"
                        :class="{ 'error-border-input': isErrorSubmit }"
                        @paste="handlePaste"
                        @keydown="handleKeyDown"
                      />
                    </b-form-group>
                    <b-input-label-info
                      v-if="(form.waybill_number?form.waybill_number.length : 0) != settingWaybillLength"
                      :left="105"
                    />
                  </div>
                </b-col>
                <b-col cols="auto">
                  <WaybillSearch
                    :waybill-number="form.waybill_number"
                    @search="getOrderDetails(form.waybill_number)"
                  />
                </b-col>
                <b-col
                  cols="6"
                  :md="orderSettings.truck_driver_enabled ? 2 : 3"
                >
                  <!-- Original Warehouse Dropdown Code -->
                  <b-form-group
                    label="Warehouse"
                    label-for="warehouse"
                  >
                    <v-select
                      :key="formKey"
                      v-model="form.warehouse_id"
                      :options="warehouseOptions"
                      :reduce="option => option.id"
                      label="name"
                      :disabled="inputDisabled"
                      :class="{ 'error-border-select': isErrorSubmit }"
                    >
                      <template v-slot:option="option">
                        {{ option.name }}
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col
                  cols="6"
                  :md="orderSettings.truck_driver_enabled ? 2 : 3"
                >
                  <b-form-group
                    label="City"
                    label-for="city"
                  >
                    <v-select
                      :key="formKey"
                      v-model="form.destination_city_id"
                      :options="cityOptions"
                      :reduce="option => option.id"
                      label="name"
                      :disabled="inputDisabled || !form.warehouse_id"
                      :class="{ 'error-border-select': isErrorSubmit }"
                    >
                      <template v-slot:option="option">
                        {{ option.name }}
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="orderSettings.truck_driver_enabled"
                  cols="6"
                  md="2"
                >
                  <ValidationProvider
                    #default="{ errors }"
                    name="Driver"
                    rules="required"
                  >
                    <b-form-group
                      label="Driver"
                      label-for="driver"
                    >
                      <v-select
                        v-model="form.driver_id"
                        :options="driverOptions"
                        :reduce="option => option.id"
                        label="first_name"
                        placeholder="Select Driver"
                      >
                        <template v-slot:option="option">
                          {{ option.first_name }} {{ option.last_name }}
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <!-- submit and reset -->
                <b-col
                  cols="12"
                  md="2"
                >
                  <b-button
                    type="submit"
                    class="vh-5 mt-2 ml-md-1 custom-button-color"
                    :disabled="!(
                      form.warehouse_id &&
                      form.destination_city_id &&
                      form.waybill_number
                    ) || loadingResponse"
                  >
                    {{ loadingResponse ? 'Submitting...' : 'Submit' }}
                  </b-button>
                </b-col>
              </b-row>
              <b-row
                v-if="!orderSettings.truck_driver_enabled"
              >
                <br>
                <b-col
                  cols="6"
                  md="3"
                >
                  <b-form-checkbox
                    id="auto-submit"
                    v-model="isAutoSubmit"
                    class="mt-1 mt-md-0"
                    name="auto-submit"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Auto Submit
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-form>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-card>
    <b-card-actions
      title="Filters"
      action-collapse
      collapsed
    >
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Received Date"
            label-for="basicInput"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'right'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Merchant"
            label-for="merchant"
          >
            <v-select
              v-model="filters['merchant_id']"
              :options="merchantOptions"
              :reduce="option => option.id"
              label="name"
              placeholder="Select Merchant"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card no-body>
      <div class="m-2">
        <b-row cols="12">
          <b-col
            md="12"
            lg="4"
            class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
          >
            <bulk-submit
              :status-key="status_key"
              :selected-waybills="selectedWaybillArray"
              @bulkSubmit="onClickBulkAction"
            />
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-center mb-1 mb-md-0"
          >
            <b-button
              type="submit"
              class="custom-button-color-blur"
              :disabled="false"
            >
              Scanned Orders : {{ submitCount }}
            </b-button>
          </b-col>
          <b-col
            class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
          >
            <ReportTableButtons
              :items="rows"
              :json_fieldz="json_fields"
              :name="`DispatchedFromOriginWarehouse - Page ${page}.xls`"
              :bulkname="`DispatchedFromOriginWarehouse.xls`"
              :fetch="getOrderListNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>
        <b-row>
          <div class="font-weight-bolder text-muted ml-1 mt-1">
            {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
          </div>
        </b-row>
      </div>
      <!--Table-->
      <b-row>
        <b-col>
          <b-overlay
            id="overlay-background"
            blur="10px"
            opacity="0.30"
            rounded="sm"
            variant="light"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template #head(id)>
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template #cell(id)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(getCustomerFieldValue(data.item, 'customer_name'))"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      :class="{'font-weight-bolder ml-1 text-danger': data.item.temporary_warehouse_id !=null ,'font-weight-bolder ml-1 text-primary':data.item.temporary_warehouse_id ===null}"
                      @click="onClickViewOrderModal(data.item)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ __orderMerchantName(data.item) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ getCustomerFieldValue(data.item, 'customer_name') }}
                    </div>
                    <div
                      v-if="getCustomerFieldValue(data.item, 'customer_email')"
                      class="font-small-2"
                    >
                      {{ getCustomerFieldValue(data.item, 'customer_email') }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ getCustomerFieldValue(data.item, 'customer_phone') }}</div>
                    </div>
                    <div
                      v-if="shouldShowSecondaryPhone(data.item)"
                      class="font-small-2"
                    >
                      <div><b>Second number: </b>{{ getCustomerFieldValue(data.item, 'customer_secondary_phone') }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ getCustomerFieldValue(data.item, 'customer_address') }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(origin_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.origin_city.name }}
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(destination_warehouse)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      CITY - {{ data.item.destination_city.name }}
                      <!--                    </b-badge>-->
                    </div>
                    <div class="font-small-2">
                      Warehouse - {{ data.value.name || 'N/A' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(finance)="data">
                <div
                  v-if="__getMerchantType(data.item) !== 'WC'"
                  class="width-150"
                >
                  <b>Total&nbsp;:</b>&nbsp;&nbsp;{{ data.item.cod || '---' }}
                  <div style="height:8px;" />
                  <b>Collected&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                </div>
                <div
                  v-else
                  class="width-150"
                >
                  <b>D-Charge&nbsp;:</b>&nbsp;&nbsp;{{ data.item.delivery_charge || '---' }}
                  <div style="height:8px;" />
                  <b>Advance&nbsp;:</b>&nbsp;&nbsp;{{ data.item.collected_cod || '---' }}
                  <div style="height:8px;" />
                  <b>Balance&nbsp;:</b>&nbsp;&nbsp;{{ (data.item.delivery_charge - data.item.collected_cod ) || '---' }}
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>

              <!-- ... Flag Componant ... -->
              <template #cell(order_flags)="data">
                <div class="d-flex align-items-center">
                  <FlagDisplay :flags="data.item.order_flags" />
                </div>
              </template>

              <template #cell(status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    @click="onClickViewOrderModal(data.item)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-overlay>

          <div class="mx-2 mb-2">
            <b-row
              cols="12"
            >
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-100"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="(meta.total)? meta.total : 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <bulk-action-modal
      ref="bulkActionModal"
      :form_structure="formStructure"
      :status_key="status_key"
      :selected_waybill_array="selectedWaybillArray"
      :truck_driver="orderSettings.truck_driver_enabled"
    />
    <operation-view-order-modal ref="operationViewOrderModal" />
  </div>
</template>

<script>
import {
  BAvatar,
  BRow,
  BCol,
  BTable,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BForm,
  BPagination,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  VBTooltip,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import { avatarText } from '@core/utils/filter'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store'
import BInputLabelInfo from '@/@core/components/b-input-label-info/BInputLabelInfo.vue'
import BFreezeLabelInfo from '@/@core/components/b-freeze-label-info/BFreezeLabelInfo.vue'
import OperationViewOrderModal from '@/components/AllOrders/OperationViewOrderModal.vue'
import FlagDisplay from '@/components/AllOrders/OrderFlags/FlagDisplay.vue'
import BulkActionModal from './bulk-actions/BulkActionModal.vue'
import AutoFetch from './AutoFetch'
import WaybillSearch from './WaybillSearch/WaybillSearch.vue'
import BulkSubmit from './bulk-actions/BulkSubmit.vue'

const orderRepository = RepositoryFactory.get('order')
const ResourceRepository = RepositoryFactory.get('resource')
const merchantRepository = RepositoryFactory.get('merchant')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
const RiderRepository = RepositoryFactory.get('rider')

export default {
  name: 'KeyTen',
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    AdvancedDateFilter,
    BAvatar,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardActions,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BPagination,
    BOverlay,
    OrderStatusBadge,
    BDropdown,
    BDropdownItem,
    BulkActionModal,
    BFormCheckbox,
    OperationViewOrderModal,
    vSelect,
    BInputLabelInfo,
    BFreezeLabelInfo,
    WaybillSearch,
    FlagDisplay,
    BulkSubmit,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, AutoFetch],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Table Info
      submitCount: 0,
      isAutoSubmit: false,
      isErrorSubmit: false,
      freezeWarehouseCheckbox: false,
      dataLoading: false,
      loadingResponse: false,
      avatarText,
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
      },
      total: 0,
      meta: {},
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterName: '',
      merchantOptions: [],
      warehouseOptions: [],
      driverOptions: [],
      cityOptions: [],
      fields: [],
      json_fields: {
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value}"`,
        },
        'Origin City': {
          field: 'origin_city.name',
          callback: value => `"${value}"`,
        },
        'Origin Warehouse': {
          field: 'origin_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Destination City': {
          field: 'destination_city.name',
          callback: value => `"${value}"`,
        },
        'Destination Warehouse': {
          field: 'destination_warehouse.name',
          callback: value => `"${value}"`,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value}"`, // Wrap the address in double quotes
        },
        'Customer Phone': 'customer_phone',
        'Second Phone Number': 'customer_secondary_phone',
        COD: 'cod',
        'Collected Cod': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        Weight: 'weight',
        Flag: {
          field: 'order_flags',
          callback: value => {
            const flagNames = value.map(flag => flag.name).join(', ')
            return `"${flagNames}"`
          },
        },
        Status: 'status.name',
      },
      rows: [],
      // Form Info
      form: {},
      formStructure: [
        {
          type: 'input',
          placeholder: '',
          inputType: 'text',
          title: 'Waybill Number',
          value: 'waybill_number',
          class: 'col-6 col-md-3',
          validation: 'required',
        },
        {
          type: 'select',
          placeholder: '',
          title: 'Warehouse',
          value: 'warehouse_id',
          class: 'col-6 col-md-3',
          fetch: ResourceRepository.getWarehouseListForDropDown(true),
          fetchData: localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : null,
          fetchFilter: warehouse => ({ label: `${warehouse.name} - ${warehouse.ref_no}`, value: warehouse.id }),
          multiple: false,
          onChange: this.onWarehouseChange,
        },
        {
          type: 'select',
          placeholder: '',
          title: 'City',
          value: 'destination_city_id',
          class: 'col-6 col-md-3',
          fetch: ResourceRepository.getCityDropdownListMultilingual,
          fetchData: localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : null,
          fetchFilter: city => ({ label: `${city.name}`, value: city.id }),
          multiple: false,
          disabled: true,
        },
        {
          type: 'select',
          placeholder: '',
          title: 'Driver',
          value: 'driver_id',
          class: 'col-6 col-md-3',
          fetch: RiderRepository.getDriverListForDropdown,
          fetchData: localStorage.getItem('driver_list') ? JSON.parse(localStorage.getItem('driver_list')) : null,
          fetchFilter: driver => ({ label: `${driver.first_name}`, value: driver.id }),
          multiple: false,
        },
      ],
      selectedWaybillArray: [],
      waybillData: [],
      formKey: 0,
      inputDisabled: true,
      orderSettings: {},
      settingWaybillLength: 0,
      selectAllCheckbox: false,
      waybillSeriesList: [],
      prefixList: [],
      matchingSeries: [],
      prefixMatch: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    page() {
      this.getOrderList()
    },
    perPage() {
      this.getOrderList()
    },
    waybillData: {
      handler(val) {
        let waybillLocated = false
        val.forEach((data, index) => {
          if (data.waybill_number && this.form.waybill_number) {
            if (data.waybill_number.toLowerCase() === this.form.waybill_number.toLowerCase()) {
              waybillLocated = true
              if (!this.form.weight || (this.waybillData.length > 1 && Object.keys(this.waybillData[index - 1] || {}).length > 0)) {
                this.$set(this.form, 'warehouse_id', data.destination_warehouse.id || '')
                this.$set(this.form, 'destination_city_id', data.destination_city_id || '')
              }
              this.formKey += 1
              this.inputDisabled = false
              this.$refs.waybill.focus()
            }
          }
        })
        if (!waybillLocated) {
          this.$set(this.form, 'warehouse_id', '')
          this.$set(this.form, 'destination_city_id', '')
          this.inputDisabled = true
        }
      },
      deep: true,
    },
    // eslint-disable-next-line func-names
    'form.warehouse_id': async function (newValue, oldValue) {
      if (newValue !== '') {
        // Clear previously selected city when warehouse changes (except initial load)
        if (oldValue !== undefined && oldValue !== '') {
          this.$set(this.form, 'destination_city_id', '')
        }
        // Load cities based on selected warehouse
        await this.getCityListByWarehouse(newValue)
        if (this.isAutoSubmit && this.form.waybill_number && this.form.destination_city_id) {
          await this.onSubmit()
        }
      } else {
        // Clear city when warehouse is cleared
        this.$set(this.form, 'destination_city_id', '')
      }
    },
    freezeWarehouseCheckbox(newIsFreezedWarehouse) {
      if (!newIsFreezedWarehouse) {
        // If isAutoSubmit becomes false, clear the freezeWeight value
        this.clearFormData()
      }
    },
  },
  async mounted() {
    this.fields.push(
      {
        key: 'id',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'waybill_number',
        label: 'Way Bill Number',
        sortable: true,
      },
      {
        key: 'merchant.name',
        label: 'Merchant',
        sortable: true,
      },
      {
        key: 'customer_name',
        label: 'Customer Name',
        sortable: true,
        thClass: 'd-none',
        tdClass: 'd-none',
      },
      {
        key: 'origin_warehouse',
        label: 'Origin',
        sortable: true,
      },
      {
        key: 'destination_warehouse',
        label: 'Destination',
        sortable: true,
      },
      {
        key: 'customer_email',
        label: 'Customer',
        sortable: true,
      },
      {
        key: 'finance',
        label: `Finance(${this.currency_type})`,
        sortable: false,
      },
      {
        key: 'weight',
        label: 'Weight',
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'order_flags',
        label: 'Flags',
        sortable: false,
      },
      {
        key: 'status.key',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'action',
        label: 'Action',
        sortable: false,
      },
    )
    this.totalRows = this.rows.length
    this.getMerchantList()
    this.getWarehouseList()
    await this.getWaybillSeriesList()
    await this.getCityListForDropDown()
    await this.readOrderSetting()
    this.inputDisabled = true
  },
  methods: {
    async onWarehouseChange(warehouseId) {
      if (warehouseId) {
        // Load cities based on selected warehouse
        await this.getCityListByWarehouse(warehouseId)

        // Update the formStructure city dropdown fetchData with filtered cities and enable it
        const cityFormIndex = this.formStructure.findIndex(field => field.value === 'destination_city_id')
        if (cityFormIndex !== -1) {
          this.$set(this.formStructure[cityFormIndex], 'fetchData', this.cityOptions)
          this.$set(this.formStructure[cityFormIndex], 'disabled', false) // Enable city dropdown
          // Clear any previously selected city when warehouse changes
          this.$set(this.form, 'destination_city_id', '')
          // Store filtered cities in localStorage for persistence
          localStorage.setItem('city_list_by_warehouse', JSON.stringify(this.cityOptions))
        }
      } else {
        // Clear city options when no warehouse is selected and disable city dropdown
        const cityFormIndex = this.formStructure.findIndex(field => field.value === 'destination_city_id')
        if (cityFormIndex !== -1) {
          this.$set(this.formStructure[cityFormIndex], 'fetchData', [])
          this.$set(this.formStructure[cityFormIndex], 'disabled', true) // Disable city dropdown
          this.$set(this.form, 'destination_city_id', '')
        }
        this.cityOptions = []
        localStorage.removeItem('city_list_by_warehouse')
      }
    },
    handlePaste(event) {
      // Access the pasted value from the event
      const pastedText = event.clipboardData.getData('text')
      // Call your function with the pasted value or perform actions as needed
      this.getOrderDetails(pastedText)
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        this.getData()
      }
    },
    getData() {
      this.getOrderDetails(this.form.waybill_number)
    },
    async getOrderDetails(waybill) {
      try {
        const { data } = (await orderRepository.fetchOrderData(waybill)).data
        this.waybillData.push(data)
      } catch (e) {
        this.waybillData.push({})
      }
    },
    async getOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await orderRepository.getOrderListByKey(this.status_key, this.page, this.perPage, filterQuery))
        this.rows = data.data
        this.meta = data.meta
        this.submitCount = 0
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await orderRepository.getOrderListByKeyNoPagination(this.status_key, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async getCityListForDropDown() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListMultilingual(this.search)).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCityListByWarehouse(warehouseId) {
      try {
        const { data } = await ResourceRepository.getCityListByWarehouse(warehouseId)
        this.cityOptions = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getWarehouseList() {
      try {
        this.warehouseOptions = localStorage.getItem('warehouse_list') ? JSON.parse(localStorage.getItem('warehouse_list')) : (await ResourceRepository.getWarehouseListForDropDown(true)).data.data
        if (!localStorage.getItem('warehouse_list')) localStorage.setItem('warehouse_list', JSON.stringify(this.warehouseOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
        this.settingWaybillLength = this.orderSettings.waybill_setting.auto_waybill_prefix.length + Number(this.orderSettings.waybill_setting.digit_count)
        if (this.orderSettings.waybill_setting.suffix_enabled) this.settingWaybillLength += this.orderSettings.waybill_setting.auto_waybill_suffix.length
        if (!this.orderSettings.truck_driver_enabled) this.formStructure.pop()
        else this.getDriverOptions()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onSubmit() {
      this.loadingResponse = true
      try {
        // Check for warehouse mismatch when checkbox is checked
        if (this.freezeWarehouseCheckbox === true) {
          if (this.form.warehouse_id !== this.filters.destination_warehouse) {
            this.showErrorMessage('The order warehouse and the freeze warehouse are not same, Please disable the freeze warehouse or change the freeze warehouse to the order warehouse.')
            this.errorSubmit()
            return
          }
          const payload = {
            waybill_numbers: [],
          }
          payload.waybill_numbers.push(this.form.waybill_number)
          payload.status_key = this.status_key
          payload.other_details = {
            warehouse_id: this.form.warehouse_id,
            destination_city_id: this.form.destination_city_id,
            driver_id: this.form.driver_id,
          }
          payload.truck_driver = this.orderSettings.truck_driver_enabled
          await orderRepository.updateOrderStatus(payload)
          this.waybillData = []
          // await this.getOrderList()
          this.showSuccessMessage('Order updated successfully')
          this.submitCount += 1
          this.clearFormData()
        } else {
          this.showErrorMessage('Please Select The Warehouse and Freeze Before Dispatch The Order')
          this.errorSubmit()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
        this.errorSubmit()
      }
    },
    clearFormData() {
      this.isErrorSubmit = false
      this.$set(this.form, 'waybill_number', '')
      this.$set(this.form, 'warehouse_id', '')
      this.$set(this.form, 'destination_city_id', '')
      this.loadingResponse = false
      this.$nextTick(() => {
        this.$refs.waybill.focus()
      })
    },
    errorSubmit() {
      this.isErrorSubmit = true
      this.loadingResponse = false
      this.$nextTick(() => {
        this.$refs.waybill.focus()
      })
    },
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await merchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async getDriverOptions() {
      try {
        this.driverOptions = localStorage.getItem('driver_list') ? JSON.parse(localStorage.getItem('driver_list')) : (await RiderRepository.getDriverListForDropdown()).data.data
        if (!localStorage.getItem('driver_list')) localStorage.setItem('driver_list', JSON.stringify(this.driverOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onClickViewOrderModal(order) {
      if (!order) {
        return
      }
      const orderId = order.id || order.order_id
      if (!orderId) {
        return
      }
      this.$refs.operationViewOrderModal.openWithOrder(order)
    },
    onClickBulkAction() {
      this.$refs.bulkActionModal.openModal()
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselctAll() {
      this.selectedWaybillArray = []
    },
    filterQueryUpdate() {
      this.getOrderList()
      this.onClickDeselctAll()
    },
    handleChangePage(page) {
      this.page = page
      this.getOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchOrderList()
      }
    },
    onClickRefresh() {
      this.getOrderList()
    },
    toggleSelectDisableStatus(disabled) {
      this.formStructure[1].disabled = disabled
      this.formStructure[2].disabled = disabled
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
    getCustomerFieldValue(item, fieldName) {
      // If order is encrypted
      if (item.is_encrypted) {
        // If user has permission to view decrypted data, show real values
        if (this.$can('show-decrypted-orders')) {
          // API returns decrypted data when user has permission, so show real value
          return item[fieldName] || ''
        }
        // User doesn't have permission - show masked
        return '******'
      }

      // Order is not encrypted - show normal data
      return item[fieldName] || ''
    },
    shouldShowSecondaryPhone(item) {
      if (!item) return false
      const hasSecondaryPhone = item.customer_secondary_phone !== null
        && item.customer_secondary_phone !== undefined
        && item.customer_secondary_phone !== ''
      const isMaskingEncrypted = item.is_encrypted && !this.$can('show-decrypted-orders')
      return hasSecondaryPhone || isMaskingEncrypted
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
